export const CUSTOMER_TOKEN = 'CUSTOMER_TOKEN';
export const AUTHENTICATED = 'AUTHENTICATED';
export const CUSTOMER_ID = 'CUSTOMER_ID';
export const CUSTOMER_GROUP_ID = "CUSTOMER_GROUP_ID";
export const COMPANY_NAME = "COMPANY_NAME";